/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */

import React from 'react';
import Figure from '../Figure';
import FigCaption from '../FigCaption';
import FigContainer from '../FigContainer';
import CategoryHeader from '../CategoryHeader';

/* eslint-disable prettier/prettier */
import IconAddToQueue from '../../../../../../Icon/IconAddToQueue';
import IconAirplay from '../../../../../../Icon/IconAirplay';
import IconAlbum from '../../../../../../Icon/IconAlbum';
import IconArtTrack from '../../../../../../Icon/IconArtTrack';
import IconAvTimer from '../../../../../../Icon/IconAvTimer';
import IconBrandingWatermark from '../../../../../../Icon/IconBrandingWatermark';
import IconCallToAction from '../../../../../../Icon/IconCallToAction';
import IconClosedCaption from '../../../../../../Icon/IconClosedCaption';
import IconEqualizer from '../../../../../../Icon/IconEqualizer';
import IconExplicit from '../../../../../../Icon/IconExplicit';
import IconFastForward from '../../../../../../Icon/IconFastForward';
import IconFastRewind from '../../../../../../Icon/IconFastRewind';
import IconFeaturedPlayList from '../../../../../../Icon/IconFeaturedPlayList';
import IconFeaturedVideo from '../../../../../../Icon/IconFeaturedVideo';
import IconFiberDvr from '../../../../../../Icon/IconFiberDvr';
import IconFiberManualRecord from '../../../../../../Icon/IconFiberManualRecord';
import IconFiberNew from '../../../../../../Icon/IconFiberNew';
import IconFiberPin from '../../../../../../Icon/IconFiberPin';
import IconFiberSmartRecord from '../../../../../../Icon/IconFiberSmartRecord';
import IconForward10 from '../../../../../../Icon/IconForward10';
import IconForward30 from '../../../../../../Icon/IconForward30';
import IconForward5 from '../../../../../../Icon/IconForward5';
import IconGames from '../../../../../../Icon/IconGames';
import IconHd from '../../../../../../Icon/IconHd';
import IconHearing from '../../../../../../Icon/IconHearing';
import IconHighQuality from '../../../../../../Icon/IconHighQuality';
import IconLibraryAdd from '../../../../../../Icon/IconLibraryAdd';
import IconLibraryBooks from '../../../../../../Icon/IconLibraryBooks';
import IconLibraryMusic from '../../../../../../Icon/IconLibraryMusic';
import IconLoop from '../../../../../../Icon/IconLoop';
import IconMic from '../../../../../../Icon/IconMic';
import IconMicNone from '../../../../../../Icon/IconMicNone';
import IconMicOff from '../../../../../../Icon/IconMicOff';
import IconMovie from '../../../../../../Icon/IconMovie';
import IconMusicVideo from '../../../../../../Icon/IconMusicVideo';
import IconNewReleases from '../../../../../../Icon/IconNewReleases';
import IconNotInterested from '../../../../../../Icon/IconNotInterested';
import IconNote from '../../../../../../Icon/IconNote';
import IconPause from '../../../../../../Icon/IconPause';
import IconPauseCircleFilled from '../../../../../../Icon/IconPauseCircleFilled';
import IconPauseCircleOutline from '../../../../../../Icon/IconPauseCircleOutline';
import IconPlayArrow from '../../../../../../Icon/IconPlayArrow';
import IconPlayCircleFilled from '../../../../../../Icon/IconPlayCircleFilled';
import IconPlayCircleOutline from '../../../../../../Icon/IconPlayCircleOutline';
import IconPlaylistAdd from '../../../../../../Icon/IconPlaylistAdd';
import IconPlaylistAddCheck from '../../../../../../Icon/IconPlaylistAddCheck';
import IconPlaylistPlay from '../../../../../../Icon/IconPlaylistPlay';
import IconQueue from '../../../../../../Icon/IconQueue';
import IconQueueMusic from '../../../../../../Icon/IconQueueMusic';
import IconQueuePlayNext from '../../../../../../Icon/IconQueuePlayNext';
import IconRadio from '../../../../../../Icon/IconRadio';
import IconRecentActors from '../../../../../../Icon/IconRecentActors';
import IconRemoveFromQueue from '../../../../../../Icon/IconRemoveFromQueue';
import IconRepeat from '../../../../../../Icon/IconRepeat';
import IconRepeatOne from '../../../../../../Icon/IconRepeatOne';
import IconReplay10 from '../../../../../../Icon/IconReplay10';
import IconReplay from '../../../../../../Icon/IconReplay';
import IconReplay30 from '../../../../../../Icon/IconReplay30';
import IconReplay5 from '../../../../../../Icon/IconReplay5';
import IconShuffle from '../../../../../../Icon/IconShuffle';
import IconSkipNext from '../../../../../../Icon/IconSkipNext';
import IconSkipPrevious from '../../../../../../Icon/IconSkipPrevious';
import IconSlowMotionVideo from '../../../../../../Icon/IconSlowMotionVideo';
import IconSnooze from '../../../../../../Icon/IconSnooze';
import IconSortByAlpha from '../../../../../../Icon/IconSortByAlpha';
import IconStop from '../../../../../../Icon/IconStop';
import IconSubscriptions from '../../../../../../Icon/IconSubscriptions';
import IconSubtitles from '../../../../../../Icon/IconSubtitles';
import IconSurroundSound from '../../../../../../Icon/IconSurroundSound';
import IconVideoCall from '../../../../../../Icon/IconVideoCall';
import IconVideoLabel from '../../../../../../Icon/IconVideoLabel';
import IconVideoLibrary from '../../../../../../Icon/IconVideoLibrary';
import IconVideocam from '../../../../../../Icon/IconVideocam';
import IconVideocamOff from '../../../../../../Icon/IconVideocamOff';
import IconVolumeDown from '../../../../../../Icon/IconVolumeDown';
import IconVolumeMute from '../../../../../../Icon/IconVolumeMute';
import IconVolumeOff from '../../../../../../Icon/IconVolumeOff';
import IconVolumeUp from '../../../../../../Icon/IconVolumeUp';
import IconWeb from '../../../../../../Icon/IconWeb';
import IconWebAsset from '../../../../../../Icon/IconWebAsset';

export default function AvIcons() {
  return (
    <div>
      <CategoryHeader>av</CategoryHeader>
      <FigContainer>
        <Figure tabIndex={0}>
          <IconAddToQueue size="32"/>
          <FigCaption>
            IconAddToQueue
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAirplay size="32"/>
          <FigCaption>
            IconAirplay
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAlbum size="32"/>
          <FigCaption>
            IconAlbum
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconArtTrack size="32"/>
          <FigCaption>
            IconArtTrack
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAvTimer size="32"/>
          <FigCaption>
            IconAvTimer
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBrandingWatermark size="32"/>
          <FigCaption>
            IconBrandingWatermark
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCallToAction size="32"/>
          <FigCaption>
            IconCallToAction
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconClosedCaption size="32"/>
          <FigCaption>
            IconClosedCaption
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconEqualizer size="32"/>
          <FigCaption>
            IconEqualizer
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconExplicit size="32"/>
          <FigCaption>
            IconExplicit
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFastForward size="32"/>
          <FigCaption>
            IconFastForward
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFastRewind size="32"/>
          <FigCaption>
            IconFastRewind
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFeaturedPlayList size="32"/>
          <FigCaption>
            IconFeaturedPlayList
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFeaturedVideo size="32"/>
          <FigCaption>
            IconFeaturedVideo
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFiberDvr size="32"/>
          <FigCaption>
            IconFiberDvr
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFiberManualRecord size="32"/>
          <FigCaption>
            IconFiberManualRecord
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFiberNew size="32"/>
          <FigCaption>
            IconFiberNew
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFiberPin size="32"/>
          <FigCaption>
            IconFiberPin
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFiberSmartRecord size="32"/>
          <FigCaption>
            IconFiberSmartRecord
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconForward10 size="32"/>
          <FigCaption>
            IconForward10
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconForward30 size="32"/>
          <FigCaption>
            IconForward30
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconForward5 size="32"/>
          <FigCaption>
            IconForward5
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconGames size="32"/>
          <FigCaption>
            IconGames
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconHd size="32"/>
          <FigCaption>
            IconHd
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconHearing size="32"/>
          <FigCaption>
            IconHearing
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconHighQuality size="32"/>
          <FigCaption>
            IconHighQuality
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLibraryAdd size="32"/>
          <FigCaption>
            IconLibraryAdd
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLibraryBooks size="32"/>
          <FigCaption>
            IconLibraryBooks
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLibraryMusic size="32"/>
          <FigCaption>
            IconLibraryMusic
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLoop size="32"/>
          <FigCaption>
            IconLoop
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMic size="32"/>
          <FigCaption>
            IconMic
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMicNone size="32"/>
          <FigCaption>
            IconMicNone
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMicOff size="32"/>
          <FigCaption>
            IconMicOff
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMovie size="32"/>
          <FigCaption>
            IconMovie
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMusicVideo size="32"/>
          <FigCaption>
            IconMusicVideo
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconNewReleases size="32"/>
          <FigCaption>
            IconNewReleases
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconNotInterested size="32"/>
          <FigCaption>
            IconNotInterested
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconNote size="32"/>
          <FigCaption>
            IconNote
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPause size="32"/>
          <FigCaption>
            IconPause
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPauseCircleFilled size="32"/>
          <FigCaption>
            IconPauseCircleFilled
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPauseCircleOutline size="32"/>
          <FigCaption>
            IconPauseCircleOutline
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPlayArrow size="32"/>
          <FigCaption>
            IconPlayArrow
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPlayCircleFilled size="32"/>
          <FigCaption>
            IconPlayCircleFilled
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPlayCircleOutline size="32"/>
          <FigCaption>
            IconPlayCircleOutline
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPlaylistAdd size="32"/>
          <FigCaption>
            IconPlaylistAdd
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPlaylistAddCheck size="32"/>
          <FigCaption>
            IconPlaylistAddCheck
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPlaylistPlay size="32"/>
          <FigCaption>
            IconPlaylistPlay
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconQueue size="32"/>
          <FigCaption>
            IconQueue
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconQueueMusic size="32"/>
          <FigCaption>
            IconQueueMusic
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconQueuePlayNext size="32"/>
          <FigCaption>
            IconQueuePlayNext
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRadio size="32"/>
          <FigCaption>
            IconRadio
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRecentActors size="32"/>
          <FigCaption>
            IconRecentActors
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRemoveFromQueue size="32"/>
          <FigCaption>
            IconRemoveFromQueue
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRepeat size="32"/>
          <FigCaption>
            IconRepeat
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRepeatOne size="32"/>
          <FigCaption>
            IconRepeatOne
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconReplay10 size="32"/>
          <FigCaption>
            IconReplay10
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconReplay size="32"/>
          <FigCaption>
            IconReplay
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconReplay30 size="32"/>
          <FigCaption>
            IconReplay30
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconReplay5 size="32"/>
          <FigCaption>
            IconReplay5
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconShuffle size="32"/>
          <FigCaption>
            IconShuffle
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSkipNext size="32"/>
          <FigCaption>
            IconSkipNext
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSkipPrevious size="32"/>
          <FigCaption>
            IconSkipPrevious
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSlowMotionVideo size="32"/>
          <FigCaption>
            IconSlowMotionVideo
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSnooze size="32"/>
          <FigCaption>
            IconSnooze
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSortByAlpha size="32"/>
          <FigCaption>
            IconSortByAlpha
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconStop size="32"/>
          <FigCaption>
            IconStop
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSubscriptions size="32"/>
          <FigCaption>
            IconSubscriptions
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSubtitles size="32"/>
          <FigCaption>
            IconSubtitles
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSurroundSound size="32"/>
          <FigCaption>
            IconSurroundSound
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconVideoCall size="32"/>
          <FigCaption>
            IconVideoCall
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconVideoLabel size="32"/>
          <FigCaption>
            IconVideoLabel
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconVideoLibrary size="32"/>
          <FigCaption>
            IconVideoLibrary
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconVideocam size="32"/>
          <FigCaption>
            IconVideocam
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconVideocamOff size="32"/>
          <FigCaption>
            IconVideocamOff
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconVolumeDown size="32"/>
          <FigCaption>
            IconVolumeDown
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconVolumeMute size="32"/>
          <FigCaption>
            IconVolumeMute
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconVolumeOff size="32"/>
          <FigCaption>
            IconVolumeOff
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconVolumeUp size="32"/>
          <FigCaption>
            IconVolumeUp
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconWeb size="32"/>
          <FigCaption>
            IconWeb
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconWebAsset size="32"/>
          <FigCaption>
            IconWebAsset
          </FigCaption>
        </Figure>
      </FigContainer>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/website/app/demos/Icon/components/categories/AvIcons.js